<template>
    <label class="font-medium text-sm text-skin-b-list-mute">
        <slot></slot>
    </label>  
</template>